export function getBrowserName() {
  // Opera 8.0+
  var isOpera = (!!window.opr && !!window.opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
  if (isOpera) return 'Opera';
  // Firefox 1.0+
  var isFirefox = typeof InstallTrigger !== 'undefined';
  if (isFirefox) return 'Firefox';
  // Safari 3.0+ "[object HTMLElementConstructor]"
  let isSafari =
    /constructor/i.test(window.HTMLElement) ||
    (function (p) {
      return p.toString() === '[object SafariRemoteNotification]';
    })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
  if (isSafari) return 'Safari';
  // Internet Explorer 6-11
  let isIE = !!document.documentMode;
  if (isIE) return 'Internet Explorer';
  // Edge 20+
  let isEdge = !isIE && !!window.StyleMedia;
  if (isEdge) return 'Microsoft Edge';
  // Chrome 1 - 79
  let isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
  if (isChrome) return 'Google Chrome';
  return 'Browser';
}

export function debounce(cb, wait) {
  let timeOut;
  return () => {
    if (timeOut) {
      clearTimeout(timeOut);
    }
    timeOut = setTimeout(cb, wait);
  };
}

export const getObjProp = function getObjProp() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return path.split('.').reduce((obj, key) => (obj && obj[key] ? obj[key] : null), obj);
};
